// 企業比較結果表示内容保存
export const RESULT_DATA_SET =
  "tools/comparison/corp/result-data/RESULT_DATA_SET";
// 企業比較結果表示内容クリア
export const RESULT_DATA_CLEAR =
  "tools/comparison/corp/result-data/RESULT_DATA_CLEAR";
